













































































import { Vue, Component } from 'vue-property-decorator';
import { user } from '../api';
import { List } from 'vant';
import moment from 'moment';
Vue.use(List);
@Component
export default class User extends Vue {
  page = 1;
  loading = false;
  finished = false;
  loadingStatus = true;
  refreshing: boolean = false;
  userList: any = [];

  onLoad() {
    const data = {
      unionid: window.localStorage.getItem('unionid'),
      token: window.gettoken(),
      page: this.page,
    };
    user(data).then((res: any) => {
      this.endListData(res);
    });
  }
  endListData(res: any) {
    this.page = this.page + 1;
    if (res.code === 200 && res.data && res.data.length) {
      res.data.map((item: any) => {
        item.create_date = moment(item.create_date * 1000).format('MM月DD日');
      });
      this.userList = [...this.userList, ...res.data];
    } else {
      this.finished = true;
    }
    this.loading = false;
  }
}
